/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_NextInputs */

const en_cook_next = /** @type {(inputs: Cook_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next step`)
};

const de_cook_next = /** @type {(inputs: Cook_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächster Schritt`)
};

/**
* | output |
* | --- |
* | "Next step" |
*
* @param {Cook_NextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_next = /** @type {((inputs?: Cook_NextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_NextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_next(inputs)
	return en_cook_next(inputs)
});